<template>
  <div class="lg:text-md mb-5 text-sm transition-all has-[.empty]:hidden">
    <span class="mb-3 inline-block font-bold">{{ filter.name }}</span>
    <template v-if="explanation">
      <template class="hidden md:inline-block">
        <AlgoliaExplanationButton @click="openDesktop = true" />
      </template>

      <template class="inline-block md:hidden">
        <AlgoliaExplanationButton @click="openMobile = true" />
      </template>

      <div class="hidden md:block">
        <AlgoliaFilterExplanationModal
          v-model:open="openDesktop"
          :slice="explanation"
        />
      </div>

      <div class="block md:hidden">
        <AlgoliaFilterExplanationSlide
          v-model:open="openMobile"
          :slice="explanation"
        />
      </div>
    </template>

    <div>
      <CheckboxFilter
        v-if="filter.type === 'checkbox-list'"
        :filter-attribute="filter.filterAttribute"
      />
      <CategoriesFilter
        v-else-if="filter.type === 'categories'"
        :filter-attribute="filter.filterAttribute"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import AlgoliaExplanationButton from '@/components/Buttons/AlgoliaExplanationButton.vue';
import AlgoliaFilterExplanationModal from '@/components/Slices/AlgoliaFilterExplanationModal.vue';
import AlgoliaFilterExplanationSlide from '@/components/Slices/AlgoliaFilterExplanationSlide.vue';
import CategoriesFilter from '@/pages/CategoryPage/Partials/Filters/CategoriesFilter.vue';
import CheckboxFilter from '@/pages/CategoryPage/Partials/Filters/CheckboxFilter.vue';
import { useAlgoliaPrismicStore } from '@/stores/Category/AlgoliaPrismicStore';
import { AlgoliaFilterType } from '@/types/Algolia/AlgoliaFilterType';
import { computed, ref } from 'vue';

const prismicStore = useAlgoliaPrismicStore();
export type ProductFilterProps = {
  filter: AlgoliaFilterType;
};

const { filter } = defineProps<ProductFilterProps>();

const explanation = computed(
  () => prismicStore.explanations?.[filter.prismicIdentifier]
);
const openDesktop = ref(false);
const openMobile = ref(false);
</script>
